import { Box, Typography, Link } from '@mui/material';
import { LANG } from '../../../language/lang';
import { Link as RouterLink } from 'react-router-dom'
import ContactBox from './ContactBox';

const MenuBox = ({ isMobile }) => {
    return (

        <Box
            display="flex"
            justifyContent={isMobile ? "center" : "space-between"}
            flexDirection={isMobile ? "column" : "row"}
            alignItems={isMobile ? "center" : "flex-start"}
            gap={3}
        >
            <Box
                display="flex"
                alignItems={!isMobile ? 'flex-start' : 'center'}
                flexDirection="column"
                gap={2}
            >
                {
                    !isMobile &&
                    <Typography variant="h6" color="textPrimary">
                        {LANG("MENU_ABOUT")}
                    </Typography>
                }


                <Link
                    key={`footer_menu_1`}
                    component={RouterLink}
                    to={'/contacts'}
                    color="text.primary"
                    underline="none"
                    sx={{ '&:hover': { color: 'primary.main' } }}
                >
                    {LANG("MENU_CONTACTS")}
                </Link>

                <Link
                    key={`footer_menu_2`}
                    component={RouterLink}
                    to={'/rules'}
                    color="text.primary"
                    underline="none"
                    sx={{ '&:hover': { color: 'primary.main' } }}
                >
                    {LANG("MENU_RULES")}
                </Link>

                <Link
                    key={`footer_menu_3`}
                    component={RouterLink}
                    to={'/privacy-policy'}
                    color="text.primary"
                    underline="none"
                    sx={{ '&:hover': { color: 'primary.main' } }}
                >
                    {LANG("MENU_PRIVACY")}
                </Link>

                <Link
                    key={`footer_menu_4`}
                    component={RouterLink}
                    to={'/cookie-policy'}
                    color="text.primary"
                    underline="none"
                    sx={{ '&:hover': { color: 'primary.main' } }}
                >
                    {LANG("MENU_COOKIE_POLICY")}
                </Link>

                <Link
                    key={`footer_menu_5`}
                    component={RouterLink}
                    to={'/return-policy'}
                    color="text.primary"
                    underline="none"
                    sx={{ '&:hover': { color: 'primary.main' } }}
                >
                    {LANG("MENU_RETURN_POLICY")}
                </Link>


            </Box>

            {
                !isMobile && (
                    <Box
                        display="flex"
                        alignItems={!isMobile ? 'flex-start' : 'center'}
                        flexDirection="column"
                        gap={2}
                    >
                        <Typography variant="h6" color="textPrimary">
                            {LANG("MENU_CONTACTS")}
                        </Typography>
                        <ContactBox />
                    </Box>
                )
            }

        </Box>

    );
};

export default MenuBox;